import { render, staticRenderFns } from "./ExamCheckBox.vue?vue&type=template&id=a5310866&"
import script from "./ExamCheckBox.vue?vue&type=script&lang=js&"
export * from "./ExamCheckBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "pc/components/ExamCheckBox.vue"
export default component.exports